import { useEffect, useState } from "react";

/**
 * Horizontal entrance offsets read well on wide, side-by-side layouts, but on
 * narrow screens the same element is full-width — so sliding it sideways pushes
 * content past the section edge, where `overflow: hidden` clips it. Collapse
 * the offset to 0 below the breakpoint so those sections just fade in.
 */
export function useSlideOffset(offset: number, query = "(min-width: 1024px)") {
  const [isWide, setIsWide] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia(query);
    const update = () => setIsWide(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, [query]);

  return isWide ? offset : 0;
}
